export const SAE_SERVICE = "/student-excusals/v0";
export const SAE_ACTION_CONTROLS = `${SAE_SERVICE}/action_controller`; // /<schoolYearKey>/index.json
export const SAE_OPT_OUTS_BY_STUDENT = `${SAE_SERVICE}/opt_out_student/by_student_number`; // /<studentNumber/<schoolYearKey>/index.json
